import { render } from "./IndvInfOfrMtt.vue?vue&type=template&id=36aabf2a"
import script from "./IndvInfOfrMtt.vue?vue&type=script&lang=js"
export * from "./IndvInfOfrMtt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__